<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AzkPsT/tc-custom/9780253011503.jpg?1717896384583" alt="This image is the cover for the book Golden Wave"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Golden Wave
      </h1>
      <p class="bookDescription body article font2">
        <p>In December 2004 the Indian Ocean tsunami devastated coastal regions of Sri Lanka. Six months later, Michele Ruth Gamburd returned to the village where she had been conducting research for many years and began collecting residents' stories of the disaster and its aftermath: the chaos and loss of the flood itself; the sense of community and leveling of social distinctions as people worked together to recover and regroup; and the local and national politics of foreign aid as the country began to rebuild. In The Golden Wave, Gamburd describes how the catastrophe changed social identities, economic dynamics, and political structures.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michele Ruth Gamburd
      </h2>
      
      <p class="authorDescription body article"><P>Michele Ruth Gamburd is Professor and Chair of Anthropology at Portland State University. She is author of The Kitchen Spoon's Handle: Transnationalism and Sri Lanka's Migrant Housemaids and Breaking the Ashes: The Culture of Illicit Liquor in Sri Lanka and editor (with Dennis B. McGilvray) of Tsunami Recovery in Sri Lanka: Ethnic and Regional Dimensions. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c82003a